// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import { ONBOARDING_MESSAGE_NAME } from '../const';

export const useMessagePolling = () => {
  let pollTimeoutId: NodeJS.Timer;

  function sendMessage(action: string) {
    const message = new MessageEvent('message', {
      data: { action },
    });
    window.dispatchEvent(message);
  }

  function startMessagePolling() {
    // Poll by sending message to the browser-extension's content script
    sendMessage(ONBOARDING_MESSAGE_NAME);
    pollTimeoutId = setTimeout(startMessagePolling, 1000);
  }

  function stopMessagePolling() {
    clearTimeout(pollTimeoutId);
  }

  return {
    startMessagePolling,
    stopMessagePolling,
  };
};
